import { useI18n } from "@excalidraw/excalidraw/i18n";
import { WelcomeScreen } from "@excalidraw/excalidraw/index";
import React from "react";

import { ExcalidrawLogo } from "./ExcalidrawLogo";
import { useAuth } from "excalidraw-app/context/AuthContext";

export const AppWelcomeScreen: React.FC<{
  onCollabDialogOpen: () => any;
  isCollabEnabled: boolean;
}> = React.memo((props) => {
  const { t } = useI18n();
  let headingContent;
  const auth = useAuth();
  // if (isExcalidrawPlusSignedUser) {
  //   headingContent = t("welcomeScreen.app.center_heading_plus")
  //     .split(/(Excalidraw\+)/)
  //     .map((bit, idx) => {
  //       if (bit === "Excalidraw+") {
  //         return (
  //           <a
  //             style={{ pointerEvents: POINTER_EVENTS.inheritFromUI }}
  //             href={`${
  //               import.meta.env.VITE_APP_PLUS_APP
  //             }?utm_source=excalidraw&utm_medium=app&utm_content=welcomeScreenSignedInUser`}
  //             key={idx}
  //           >
  //             Excalidraw+
  //           </a>
  //         );
  //       }
  //       return bit;
  //     });
  // } else {
  //   headingContent = t("welcomeScreen.app.center_heading");
  // }
  headingContent = (
    <p>All your data is saved locally in your browser.</p>
  );
  if (auth) {
    const { user } = auth;
    if(user){
      headingContent = (
        <>
          <h2>Welcome {user.name}!</h2>
          <p>All your data is saved locally in your browser.</p>
        </>
      );
    }
  }
  
  return (
    <WelcomeScreen>
      <WelcomeScreen.Hints.MenuHint>
        {t("welcomeScreen.app.menuHint")}
      </WelcomeScreen.Hints.MenuHint>
      <WelcomeScreen.Hints.ToolbarHint />
      <WelcomeScreen.Hints.HelpHint />
      <WelcomeScreen.Center>
        <WelcomeScreen.Center.Logo>
            <ExcalidrawLogo withText />
        </WelcomeScreen.Center.Logo>
        <WelcomeScreen.Center.Heading>
          {headingContent}
        </WelcomeScreen.Center.Heading>
      </WelcomeScreen.Center>
    </WelcomeScreen>
  );
});
